import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Swiper from "react-id-swiper";
import SectionTitleFive from "../../components/section-title/SectionTitleFive";
import { connect } from "react-redux";
import { store } from "../..";
import { fetchSuggestedProducts } from "./../../redux/actions/productActions";
import ProductGridSuggested from "./ProductGridSuggested";

const ProductSuggested = ({
  spaceTopClass,
  spaceBottomClass,
  bgColorClass,
  product,
  suggestedProductData,
  sectionTitle,
  bgShape,
  colorClass,
  settingData,
}) => {
  useEffect(() => {
    const categoryIds =
      product.categories?.map((category) => category.id).join(",") || "";
    store.dispatch(
      fetchSuggestedProducts({
        channel_id: settingData.channel_id,
        category_ids: categoryIds,
        exclude_ids: product.id,
      })
    );
  }, []);
  const [swiper, updateSwiper] = useState(null);
  // const [swiper2, updateSwiper2] = useState(null);
  // const [swiper3, updateSwiper3] = useState(null);

  const settings = {
    loop: false,
    grabCursor: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
    },
  };

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // const goNext2 = () => {
  //   if (swiper2 !== null) {
  //     swiper2.slideNext();
  //   }
  // };
  // const goPrev2 = () => {
  //   if (swiper2 !== null) {
  //     swiper2.slidePrev();
  //   }
  // };

  // const goNext3 = () => {
  //   if (swiper3 !== null) {
  //     swiper3.slideNext();
  //   }
  // };
  // const goPrev3 = () => {
  //   if (swiper3 !== null) {
  //     swiper3.slidePrev();
  //   }
  // };
  return (
     <div
      className={`product-area product-area--style2 ${
        spaceTopClass ? spaceTopClass : ""
      } ${spaceBottomClass ? spaceBottomClass : ""} ${
        bgColorClass ? bgColorClass : ""
      }`}
    >
       <div className="pro-padding">
         <div className="product-tab-slider-wrapper position-relative">
           <div className="product-top-bar section-border mb-60">
             <SectionTitleFive titleText={sectionTitle} />
           </div>
           <div className="row">
             <Swiper {...settings} getSwiper={updateSwiper}>
              <ProductGridSuggested
                suggestedProductData={suggestedProductData}
                type="new"
                limit={8}
                spaceBottomClass="mb-25"
                sliderClassName="swiper-slide"
                colorClass={colorClass}
              />
             </Swiper>
             {/* <div className="swiper-slider-navigation-wrapper product-slider-active">
               <button
                className="swiper-button-prev ht-swiper-button-nav"
                onClick={goPrev}
              >
                 <i className="pe-7s-angle-left" />
               </button>
               <button
                 className="swiper-button-next ht-swiper-button-nav"
                 onClick={goNext}
               >
               <i className="pe-7s-angle-right" />
               </button>
             </div> */}
           </div>
         </div>
       </div>
       {bgShape ? (
         <div className="bg-png-1">
           <img
           src={process.env.PUBLIC_URL + "/assets/img/bg/shape-2.png"}
             alt=""
           />
         </div>
       ) : (
         ""
       )}
     </div>
  );
};

ProductSuggested.propTypes = {
  bgColorClass: PropTypes.string,
  colorClass: PropTypes.string,
  bgShape: PropTypes.bool,
  sectionTitle: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  settingData: PropTypes.object,
  suggestedProductData: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    settingData: state.settingData.ecom.basic,
    suggestedProductData: state.productData.suggestedProducts,
  };
};

export default connect(mapStateToProps)(ProductSuggested);
